
import { defineComponent, onBeforeMount, onMounted, ref } from 'vue';
import Greetings from '@/components/global/Greetings.vue';
// import store from '@/store';

export default defineComponent({
  name: 'LearnerStatus',
  // props: ['query'],
  components: { Greetings },
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const program = ref(localStorage.getItem('programId'));
    const skill = ref(localStorage.getItem('skillName'));
    const proficiency = ref(localStorage.getItem('proficiency'));
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    const message = ref(localStorage.getItem('message'));
    const isPerformReviewVisible = ref(props.query.isPerformReviewVisible);
    const learnerTaskId = ref(props.query.learnerTaskId);
    const isProxyReview = ref(props.query.isProxyReview);
    const showChevron = ref(props.query.showChevron);
    const renderReady = ref();
    onBeforeMount(() => {
      renderReady.value = false;
    });
    onMounted(() => {
      renderReady.value = true;
    });
    return {
      message,
      isPerformReviewVisible,
      learnerTaskId,
      isProxyReview,
      showChevron,
      helpmateLink,
      renderReady,
      program,
      skill,
      proficiency,
    };
  },
});
